var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1077 8.03549C10.1077 9.19949 9.16367 10.1428 7.99967 10.1428C6.83567 10.1428 5.89233 9.19949 5.89233 8.03549C5.89233 6.87082 6.83567 5.92749 7.99967 5.92749C9.16367 5.92749 10.1077 6.87082 10.1077 8.03549Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99868 12.9032C10.5373 12.9032 12.8593 11.0779 14.1667 8.03524C12.8593 4.99257 10.5373 3.16724 7.99868 3.16724H8.00134C5.46268 3.16724 3.14068 4.99257 1.83334 8.03524C3.14068 11.0779 5.46268 12.9032 8.00134 12.9032H7.99868Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowpassword);
export default __webpack_public_path__ + "static/media/showpassword.a15ac20bbb492313f4eba4dee443a5fe.svg";
export { ForwardRef as ReactComponent };